import Cookies from 'js-cookie';
import { makeVar } from '@apollo/client';
import { GlobalCfg } from '../../conf';
import analytics from '../analytics';
import { PageRoutes } from '../../conf/Global';

export const checkAuthStatus = (): boolean => {
    const isAuthenticated = !!Cookies.get(GlobalCfg.CLIENT_AUTH_COOKIE);
    if (isAuthenticated) {
        analytics.identify(Cookies.get(GlobalCfg.CLIENT_AUTH_COOKIE) as string);
    }
    return isAuthenticated;
};

export const checkAuthStatusFromServer = async (): Promise<{
    isAuthenticated: boolean;
    playSessionExpired: boolean;
}> => {
    try {
        const response = await fetch(PageRoutes.IS_AUTHENTICATED, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.ok) {
            const data = await response.json();
            if (data.isAuthenticated) {
                analytics.identify(Cookies.get(GlobalCfg.CLIENT_AUTH_COOKIE) as string);
            }
            return { isAuthenticated: data.isAuthenticated, playSessionExpired: data.play_session_expired };
        }
        console.warn('Authentication API call failed:', response.status, response.statusText);
        return { isAuthenticated: false, playSessionExpired: false };
    } catch (error) {
        console.error('Error during authentication API call:', error);
        return { isAuthenticated: false, playSessionExpired: false };
    }
};

export const isLoggedInVar = makeVar(checkAuthStatus());
